import { render } from "./ReportStatisticPanel.vue?vue&type=template&id=3b6bc91e"
import script from "./ReportStatisticPanel.vue?vue&type=script&lang=js"
export * from "./ReportStatisticPanel.vue?vue&type=script&lang=js"

import "./ReportStatisticPanel.vue?vue&type=style&index=0&id=3b6bc91e&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn,QTable});
